module.exports = __webpack_public_path__ + "static/media/pickup_notification_banner.4ce5086c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pickup_notification_banner.png
// module id = 1038
// module chunks = 0